import { HighlightIcon } from '@dev-spendesk/grapes';
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { routeFor, routes } from 'src/core/constants/routes';
import { getDimensionIcon } from 'src/core/modules/budgets/budgets-by-dimensions/models/dimension';
import { type Budget } from 'src/core/modules/budgets/models/budget';
import { type PeriodRange } from 'src/core/modules/budgets/models/periodRange';

import { BudgetExpenseCategoriesList } from './BudgetExpenseCategoriesList';
import { BudgetRow } from './BudgetRow';
import { type BudgetBreakdown } from '../../../../models/breakdown';
import { toPeriodRangePayload } from '../../../../models/periodRange';

export const BudgetCardRow = ({
  budget,
  companyId,
  periodRange,
  breakdown,
  className,
}: {
  budget: Budget;
  companyId: string;
  periodRange: PeriodRange;
  breakdown: BudgetBreakdown;
  className?: string;
}) => {
  const history = useHistory();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const periodRangePayload = useMemo(
    () => toPeriodRangePayload(periodRange),
    [periodRange],
  );

  const handleClick = () => {
    const budgetsPageRoute = routeFor(routes.BUDGET_OVERVIEW.path, {
      id: budget.id,
      company: companyId,
    });
    history.push({
      pathname: budgetsPageRoute,
      state: {
        hasBackButton: true,
        selectedPeriodRange: periodRange,
      },
    });
  };

  return (
    <>
      <BudgetRow
        rowName={budget.name}
        breakdown={breakdown}
        collapse={{
          isCollapsed,
          onToogleCollapse: () => setIsCollapsed(!isCollapsed),
        }}
        onRowClick={handleClick}
        className={className}
        rowIcon={
          <HighlightIcon
            size={32}
            {...getDimensionIcon({ type: 'costCenter' })}
          />
        }
      />
      {isCollapsed && (
        <BudgetExpenseCategoriesList
          budgetId={budget.id}
          rowClassName={className}
          periodRange={periodRangePayload}
        />
      )}
    </>
  );
};
